/** Do not edit directly **/
/** Do not edit directly **/
/**
 * @prop --sy-dropdown-background-color: Dropdown background color.
 * @prop --sy-dropdown-border: Dropdown border.
 * @prop --sy-dropdown-border-radius: Dropdown border-radius.
 * @prop --sy-dropdown-border-color: Default border color.
 * @prop --sy-dropdown-padding: Dropdown padding.
 * @prop --sy-dropdown-shadow: Dropdown box-shadow.
 */
*,
:host,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  position: absolute;
  z-index: 1000;
  display: none;
  padding: var(--sy-dropdown-padding, 0);
  overflow: hidden;
  background-color: var(--sy-dropdown-background-color, var(--sy-surface));
  border: var(--sy-dropdown-border, 1px solid);
  border-color: var(--sy-dropdown-border-color, var(--sy-border));
  border-radius: var(--sy-dropdown-border-radius, var(--sy-border-radius));
  box-shadow: var(--sy-dropdown-shadow, var(--sy-shadow-offset-x) var(--sy-shadow-offset-y) var(--sy-shadow-radius) var(--sy-shadow));
}

:host([opened]) {
  display: block;
}